import React from 'react';
import logoImage from '../assets/smuglergods.svg';

const Hero: React.FC = () => {
  return (
    <div className="bg-[#080808] text-white relative" style={{ paddingTop: '6rem', paddingBottom: 0 }}>
      {/* Strong green radial glow */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background: 'radial-gradient(ellipse 80% 70% at 50% 40%, rgba(155,240,30,0.13) 0%, rgba(155,240,30,0.04) 50%, transparent 100%)',
        }}
      />
      {/* Horizontal scan line */}
      <div
        className="absolute left-0 right-0 pointer-events-none"
        style={{
          top: '42%',
          height: '1px',
          background: 'linear-gradient(to right, transparent, rgba(155,240,30,0.18), rgba(155,240,30,0.35), rgba(155,240,30,0.18), transparent)',
        }}
      />
      <div className="container-responsive text-center relative z-10" style={{ paddingBottom: '3rem' }}>
        <img
          src={logoImage}
          alt="Smuglergods"
          className="w-full max-w-xs sm:max-w-md md:max-w-xl mx-auto logo-filter animate-logo-glow"
        />
        {/* Tagline */}
        <p
          className="mt-6 text-xs tracking-[0.3em] uppercase font-bold"
          style={{ color: 'rgba(155,240,30,0.55)' }}
        >
          Elverum &nbsp;·&nbsp; Snus, venner og "musikk" &nbsp;·&nbsp; Est. 2000
        </p>
      </div>
      {/* Gradient fade into next section */}
      <div
        className="absolute bottom-0 left-0 right-0 pointer-events-none"
        style={{
          height: '160px',
          background: 'linear-gradient(to bottom, transparent, #080808)',
        }}
      />
    </div>
  );
};

export default Hero; 